import _ from 'lodash';
import {
    SET_IMAGE,
    SET_TEXT,
    SET_CONTAINER,
    OPEN_TRANSFORM_AREA,
    CLOSE_TRANSFORM_AREA,
    RESET_TRANSFORM_AREA,
} from '../actions/actionCreators/transformArea';

const initialState = {
    isOpen: false,
    container: null,
    image: null,
    text: null,
    containerType: null,
};

export default function transformArea(state = initialState, action) {
    let newState = _.cloneDeep(state);
    switch (action.type) {
        case OPEN_TRANSFORM_AREA:
            newState.isOpen = true;
            return newState;
        case CLOSE_TRANSFORM_AREA:
            newState.isOpen = false;
            return newState;
        case SET_CONTAINER:
            newState.container = action.container;
            newState.containerType = action.containerType;
            return newState;
        case SET_IMAGE:
            newState.image = action.image;
            return newState;
        case SET_TEXT:
            newState.text = action.text;
            return newState;
        case RESET_TRANSFORM_AREA:
            return initialState;
        default:
            return state;
    }
}
